<template>
  <vs-row class="cerca" vs-justify="center">
    <vs-col v-if="filter_list.length > 0" vs-w="2" vs-lg="2" vs-sm="4" vs-xs="12">
      <vx-tooltip text="Seleziona lo stato" position="left" :disabled="tp_bool">
        <v-select
          class="search-select v-step-7"
          :options="filter_list"
          v-model="filter_option"
          name="filter"
          :filterable="false"
          :clearable="false"
        />
      </vx-tooltip>
    </vs-col>
    <vs-col v-if="filterByYears" vs-w="2" vs-lg="2" vs-sm="4" vs-xs="12">
      <vx-tooltip text="Seleziona Anno" position="left" :disabled="tp_bool">
        <v-select
          class="search-select v-step-7"
          :options="year_list"
          v-model="year_option"
          name="filter"
          :filterable="false"
          :clearable="false"
        />
      </vx-tooltip>
    </vs-col>
    <vs-col :vs-w="filter_list.length > 0 ? 4 : 5" vs-sm="8" vs-xs="12">
      <vx-input-group class="mb-base">
        <vs-col vs-w="2" vs-sm="2" vs-xs="12">
          <vx-tooltip
            text="'Bottone ricerca, puoi usare anche il tasto Invio"
            position="left"
          >
            <vs-button class="v-step-8 w-full"
              @click="find($event)"
              color="primary"
              type="line"
              icon-pack="feather"
              icon="icon-search"
              icon-after
            />
          </vx-tooltip>
        </vs-col>
        <vs-col vs-w="10" vs-sm="10" vs-xs="12">
          <vx-tooltip :text="'Puoi cercare per: '+tooltip" position="left">
            <vs-input
              v-model="v_keyword"
              icon-pack="feather"
              icon="icon-search"
              label-placeholder="Cerca"
              class="is-label-placeholder w-full"
              icon-no-border
              @keyup.enter="find($event)"
              v-on:icon-click="test()"
            />
          </vx-tooltip>
        </vs-col>
      </vx-input-group>
    </vs-col>
    <vs-col class="searchbar-row-height" vs-w="2" vs-lg="2" vs-sm="12" vs-xs="12">
      <vs-button
        class="w-full px-1"
        color="black"
        type="line"
        disabled
      >
      {{p ? ['Pag:',p.current,'/',p.tot].join(' ') : ''}}
      </vs-button>
   </vs-col>
    <vs-col v-if="csvPresence" class="searchbar-row-height" vs-w="2" vs-lg="2" vs-sm="3" vs-xs="12">
      <vx-tooltip text="Fattura Addebiti - Scarica CSV" position="left" class="resize_limits">
        <vs-button
          :disabled="checkDisabled"
          class="v-step-8 w-full"
          @click="downloadCsv($event)"
          color="warning"
          type="line"
          icon-pack="feather"
          icon="icon-download"
          icon-after
        >
          {{ csvButton }}
        </vs-button>
      </vx-tooltip>
    </vs-col>
    <vs-col :key="index" v-for="(newText, index) in newTexts" class="searchbar-row-height" vs-w="2" vs-lg="2" vs-sm="4" vs-xs="12">
      <vx-tooltip text="Crea uno nuovo" position="left">
        <vs-button
          :disabled="dsbld"
          class="v-step-8 w-full"
          @click="create(tipo[index], $event)"
          color="success"
          type="line"
          icon-pack="feather"
          icon="icon-plus"
          icon-after
        >
          Nuovo
        </vs-button>
      </vx-tooltip>
    </vs-col>
    <vs-col v-if="syncDatabase" class="searchbar-row-height" vs-w="2" vs-lg="2" vs-sm="4" vs-xs="12">
      <vx-tooltip text="Sincronizza database, richiede tempo..." position="left">
        <vs-button
          class="w-full"
          :disabled="checkDisabled"
          @click="requestSyncDatabase($event)"
          color="warning"
          type="line"
          icon-pack="feather"
          icon="icon-sync"
          icon-after
        >
          {{ syncTimerButton }}
          <!-- {{
            this.$store.state.activeTimeout
          }}
          {{
            this.$store.state.syncTimeout
          }} -->
        </vs-button>
      </vx-tooltip>
    </vs-col>
  </vs-row>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'

export default {
  data() {
    return {
      permessi: localStorage.utente_permessi,
      utente_mail: localStorage.utente_mail,
      v_keyword: "",
      tp_bool: false,
      filter_option: "Tutti",
      year_option: new Date().getFullYear().toString(),
      // countDown: 0
    }
  },
  props: {
    newTexts: Array,
    tooltip: {
      type: String,
      default: '',
    },
    tipo: {
      type: Array,
      default: () => []
    },
    filter_list: {
      type: Array,
      required: false,
      default: () => []
    },
    p: {
      type: Object,
      required: false,
    },
    dsbld: {
      type: Boolean,
      default: () => false
    },
    csv: {
      type: Boolean,
      required: false,
      default: () => false
    },
    syncDatabase: {
      type: Boolean,
      required: false,
      default: () => false
    },
    filterByYears: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  components: {
    vSelect,
  },
  computed: {
    csvPresence: {
      get () {
        if (this.csv && (this.permessi == 0 || this.utente_mail == 'amministrazione@ascom.bo.it'))
          return true
        else return false
      }
    },
    checkDisabled: {
      get () {
        if (this.permessi == 0 || this.permessi == 1) {
          // || this.utente_mail == 'amministrazione@ascom.bo.it'
          return false
        } else if (!this.$store.state.activeTimeout) {
          return false
        } else return true
      },
      // set (v) { if (!v) this.new_form = null }
    },
    syncTimerButton() {
      return this.$store.state.activeTimeout ? this.$store.state.syncTimeout.toString() : "Sync"
    },
    csvButton() {
      return this.$store.state.activeTimeout ? this.$store.state.syncTimeout.toString() : "CSV"
    },
    year_list() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = 2018; year <= currentYear; year++) {
        years.push(year.toString());
      }
      return years;
    },
  },
  methods: {
    countDownTimer () {
      this.$store.dispatch('setSyncTimeout', localStorage.utente_mail != 'test@test.com' ? 300 : 5)
      this.$store.dispatch('timerSyncTimeout')
    },
    create(tipo, ev) {
      let evName = ['create']
      if(tipo) {
        evName.push(tipo)
      }
      // if (!_.isEmpty(this.$route.params)) {
      //   // let url = this.$router.url.substring(0, this.router.url.indexOf("?"));
      //   // this.$router.navigateByUrl(url);
      //   console.log(this.$route.params);
      // }
      this.$emit(evName.join('-'))
      ev.stopPropagation()
    },
    test() {
      console.log("QUIIIII")
    },
    find() {
      let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
      if (elements.length) {
        elements[0].remove();
      }
      if (this.v_keyword.length > 4) {
        this.$emit('find', this.v_keyword, this.filter_option)
      } else {
        this.$vs.notify({
          color: 'warning',
          time: 4000,
          title: 'Avviso Ricerca',
          text: 'la ricerca deve avere almeno 5 caratteri'
        })
      }
    },
    downloadCsv(ev) {
      this.$emit('download-csv')
      if (ev) ev.stopPropagation()
    },
    requestSyncDatabase(ev) {
      // this.countDown = 300
      if (this.utente_mail != 'test@test.com') this.countDownTimer()
      axios.get(process.env.VUE_APP_BACKEND_API+'/azienda/resultSyncDatabase',{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then((response,error) => {
        if (response) {
          console.log(response)
          this.$vs.notify({
            color: 'success',
            time: 4000,
            title: '',
            text: 'Sync avviato...'
          })
        } else {
          console.warn(error)
          this.$vs.notify({
            color: 'warning',
            time: 4000,
            title: 'Errore',
            text: error
          })
        }
        // console.log('response ',response)
      }).catch(e => { console.log(e) })
      if (ev) ev.stopPropagation()
    },
  },
  watch: {
  //   v_keyword() {
  //     if (this.v_keyword.length > 2 || this.v_keyword.length == 0) {
  //       this.find()
  //     }
  //   },
    filter_option() {
      this.$emit('find', this.v_keyword, this.filter_option)
      let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
      if (elements.length) {
        elements[0].remove();
      }
    }
  },
}
</script>

<style lang="css" scoped>
  .vs-row.cerca .con-vs-tooltip.resize_limits {
    width: min-content;
  }
  .searchbar-row-height {
    min-height: 65px;
  }
</style>
